import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';

import { LogoutService } from 'app/header/usersettings/logout.service';

@Component({
  templateUrl: './session-expired.component.html'
})

export class SessionExpiredComponent {
  constructor(private logoutService: LogoutService) {};

  reloadWindow() {
    this.logoutService.deleteCredentials();

    location.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/sessionexpired/session-expired.component.ts